<div class="account">
  <div class="content">
    <span class="account-select">
    <kion-drop-down
      [title]="component.title"
      [icon]="icon"
      [options]="links$ | async"
      [defaultLink]="'/auth'"
    ></kion-drop-down>
  </span>
  </div>
</div>
